import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './lib/supabase';
import Dashboard from './components/Dashboard';
import SprintCreation from './components/SprintCreation';
import WeeklyPlanning from './components/WeeklyPlanning';
import DailyGoals from './components/DailyGoals';
import Navigation from './components/Navigation';
import Auth from './components/Auth';
import LifeInWeeks from './components/LifeInWeeks';
import HabitTracker from './components/HabitTracker';
import Landing from './components/Landing';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // Check current session
    const checkSession = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (error) throw error;
        setIsAuthenticated(!!session);
      } catch (error) {
        console.error('Error checking session:', error);
        setIsAuthenticated(false);
      }
    };

    checkSession();

    // Set up auth state listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Show loading animation while checking auth state
  if (isAuthenticated === null) {
    return <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
    </div>;
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        {isAuthenticated && <Navigation />}
        <main className={isAuthenticated ? "container mx-auto px-4 py-8" : ""}>
          <Routes>
            <Route path="/" element={isAuthenticated ? <Dashboard /> : <Landing />} />
            <Route path="/auth" element={isAuthenticated ? <Navigate to="/" replace /> : <Auth />} />
            <Route path="/create-sprint" element={isAuthenticated ? <SprintCreation /> : <Navigate to="/auth" replace />} />
            <Route path="/weekly-planning" element={isAuthenticated ? <WeeklyPlanning /> : <Navigate to="/auth" replace />} />
            <Route path="/daily-goals" element={isAuthenticated ? <DailyGoals /> : <Navigate to="/auth" replace />} />
            <Route path="/life-in-weeks" element={isAuthenticated ? <LifeInWeeks /> : <Navigate to="/auth" replace />} />
            <Route path="/habits" element={isAuthenticated ? <HabitTracker /> : <Navigate to="/auth" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;